import React, { useState } from 'react';
import { LoginOutlined, LogoutOutlined, UserOutlined } from '@ant-design/icons';
import { Modal } from 'antd';
import { useAuth } from '../../../contexts/AuthContext';
import { useTranslation } from 'react-i18next';
import * as S from '../Header.styles';

interface MobileHeaderProps {
  toggleSider: () => void;
  isSiderOpened: boolean;
}

export const MobileHeader: React.FC<MobileHeaderProps> = ({ toggleSider, isSiderOpened }) => {
  const { i18n } = useTranslation();
  const { isInitialized, isAuthenticated, userName, login, logout } = useAuth();
  const [userModalVisible, setUserModalVisible] = useState(false);

  const handleAuthClick = async () => {
    if (isAuthenticated) {
      // Open modal for authenticated users
      setUserModalVisible(true);
    } else {
      // Always use English locale for Keycloak regardless of app language
      console.log('[MobileHeader] Current app language:', i18n.language);
      console.log('[MobileHeader] Keycloak locale: en (fixed)');
      await login('en');
    }
  };

  const handleLogout = async () => {
    setUserModalVisible(false);
    await logout();
  };

  return (
    <>
      <S.MobileHeaderRow>
        {/* Left spacer for balance */}
        <div style={{ width: '80px' }} />
        
        {/* Center: Title */}
        <S.CrmXLogoText style={{ color: 'white', flex: 1, textAlign: 'center' }}>
          Teacher's Space
        </S.CrmXLogoText>
        
        {/* Right: Auth button - показывается сразу */}
        <S.MobileSignInButton onClick={handleAuthClick}>
          {isAuthenticated ? (
            <>
              <UserOutlined />
              <span>{userName || 'User'}</span>
            </>
          ) : (
            <>
              <LoginOutlined />
              <span>Sign In</span>
            </>
          )}
        </S.MobileSignInButton>
      </S.MobileHeaderRow>

      {/* User Modal for Mobile */}
      <Modal
        open={userModalVisible}
        onCancel={() => setUserModalVisible(false)}
        footer={null}
        centered
        width={320}
        bodyStyle={{
          padding: '32px 24px',
          textAlign: 'center'
        }}
      >
        <div style={{ marginBottom: 24 }}>
          <UserOutlined style={{ fontSize: 48, color: '#1677ff', marginBottom: 16 }} />
          <div style={{ fontSize: 18, fontWeight: 600, color: '#1a1a1a', marginBottom: 8 }}>
            {userName || 'User'}
          </div>
        </div>
        <S.AuthButton 
          onClick={handleLogout} 
          $isAuthenticated={false}
          style={{ 
            width: '100%', 
            justifyContent: 'center',
            height: 44,
            fontSize: 16
          }}
        >
          <LogoutOutlined />
          <span style={{ display: 'inline' }}>Log out</span>
        </S.AuthButton>
      </Modal>
    </>
  );
};
